import React, { useState } from 'react';
import { useInput } from './Utilils/Input';


const Comment = () => {
  const name = useInput("");
  const comment = useInput("");
  const [comments, setComments] = useState([]);


  const newComment = (e) => {
    e.preventDefault();
    setComments([{name: `${name.value}`,
                  comment: `${comment.value}`
    }, ...comments]);
  }

  let display = comments.map((info, index) => {
    return (
      <div key={index} className="commentDisplay">
        <h3>{info.name}</h3>
        <p>{info.comment}</p>
      </div>
    )
  })

  return (
    <>
      <form onSubmit={newComment}>
        <label>Name:</label>
        <input type="text" placeholder="name" name="name" {...name} />
        <label>Comment:</label>
        <input type="text" placeholder="comment" name="comment" {...comment} />
        <button type="submit" className="CommentButton">Submit</button>
      </form>
      <ul>
        {display}
      </ul>
    </>
  )
}

export default Comment